<template>
  <v-main>
    <Home />
  </v-main>
</template>

<script>
import Home from "./views/Home/Home.vue";

export default {
  name: "App",

  components: {
    Home,
  },

  data: () => ({
    //
  }),
};
</script>
